<template>
  <div class="custom-order fullscreen-content">
    <banner :banner="page.data.job.banner"></banner>

    <div class="container is-md section">
      <div class="content">
        <h1 class="section-title centered">{{page.data.job.name}}</h1>
        <div v-html="page.data.job.content"></div>
      </div>
    </div>

    <div class="container is-boxed-fluid job-gallery">
      <mq-layout class="row gut-2" :mq="['md', 'lg', 'xl', 'hd', 'inf']">
        <div class="col-sm-12" v-for="(image, key) in page.data.job.images" :key="key" :class="{'col-4': key%3!=0 || key==0, 'col-12': key%3==0 && key!=0}">
          <img :src="image.img_name" alt />
        </div>
      </mq-layout>
      <mq-layout class="mobile-slider" :mq="['xs', 'sm', 'ms']">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide v-for="(image, key) in page.data.job.images" :key="key">
            <img :src="image.img_name" alt />
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-prev light" slot="button-prev"></div>
          <div class="swiper-next light" slot="button-next"></div>
        </swiper>

      </mq-layout>
    </div>

    <div class="all-jobs section">
      <slider :component="'job'" :items="page.data.last_jobs" :title="'Մեր բոլոր աշխատանքները'" :slide_count="3"></slider>
    </div>

    <div class="container section" id="request">
      <div class="row request-custom-order">
        <div class="col-6 col-md-12">
          <h2>Գրե՛ք մեզ և մեր մասնագետները Ձեզ կօգնեն իրականացնել կորպորատիվ նվերներ պատրաստելու Ձեր գաղափարը</h2>
          <p>
            Եթե ցանկանում եք պատվիրել կորպորատիվ յուրօրինակ նվերներ զանգահարեք մեզ
            <a href="tel:+374 98 228 228">+374 98 228 228</a> հեռախոսահամարով կամ գրե՛ք մեզ և մեր մասնագետները սիրով կօգնենք Ձեզ կողմնորոշվել նվերի հարցում՝ առաջարկելով լավագույն լուծումը Ձեզ համար։
          </p>
        </div>
        <div class="col-6 col-md-12">
          <div class="request-form">
            <div class="form-field">
              <input type="text" placeholder="Անուն" />
            </div>
            <div class="form-field">
              <input type="text" placeholder="Հեռախոս" />
            </div>
            <div class="form-field">
              <input type="text" placeholder="Էլ․ փոստ" />
            </div>
            <div class="form-field">
              <input type="text" placeholder="Կազմակերպություն" />
            </div>
            <div class="form-field">
              <textarea name id cols="30" rows="10" placeholder="Նամակ"></textarea>
            </div>
            <div class="form-field">
              <button class="button">SEND NOW</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/home/Banner.vue';
import Job from '@/components/items/Job.vue';
import Slider from '@/components/home/Slider.vue';
import { mapState } from 'vuex';
export default {
  components: {
    Banner,
    Job,
    Slider
  },
  name: 'custom-order',
  data () {
    return {
      banner: {
        image: '/img/custom-order/banner.jpg'
      },
      swiperOption: {
        slidesPerView: 1,
        centeredSlides: false,
        autoHeight: true,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      },
    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.custom-order {
  padding-top: 95px;

  @include mq($lg) {
    padding-top: 65px;
  }

  .content {
    p {
      margin: 0;
    }
  }

  .job-gallery {
    img {
      width: 100%;
    }
    .mobile-slider{
      margin-bottom: 30px;
    }
  }

  .request-custom-order {
    background: #eff0f0;
    padding: 70px 100px;

    @include mq($lg) {
      padding: 30px 15px;
    }

    h2 {
      margin-top: 0;
      font-family: $font-bold;
      font-size: 24px;
    }
    p {
      margin: 0;
      a {
        font-family: $font-bold;
      }
    }
    input,
    textarea {
      background: none;
    }
    textarea {
      height: 100px;
      resize: none;
      border: 1px solid #0b0b0b;
      padding-top: 15px;
    }
    .button {
      max-width: 60%;
    }
  }
}
</style>
